import Select from 'react-select'
import React from "react";
import { Form, Col } from 'react-bootstrap';
import { IListOption } from "../classes/Domain";
import * as _ from 'lodash';
import { slectColourStyles } from "../AppConstants";

const stateOptions = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "DC", label: "District Of Columbia" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
    { value: "FOR", label: "Foreign" },
    { value: "MC", label: "Matricular Consular" },
    { value: "MX", label: "Mexico" }
];

interface IStateListProps {
    label: string,
    value: string,
    className?: string,
    placeholder?: string | null,
    validated: boolean,
    validationError: string,
    disabled?: boolean,
    onChange?: (selectedState: IListOption | null) => void;
}

interface IState {
    selectedState: IListOption | null
}

export class StateList extends React.Component<IStateListProps, IState> {
    constructor(props: IStateListProps) {
        super(props);

        this.onStateChange = this.onStateChange.bind(this);

        this.state = {
            selectedState : null
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value && !prevState.value) {
            const state = _.find(stateOptions, ['value', nextProps.value]);
            return state
                ? {
                    ...prevState,
                    selectedState: state
                  }
                : prevState;
        }

        return prevState;
    }

    //onChange?: (value: ValueType<OptionType>, action: ActionMeta<OptionType>) => void;

    onStateChange(value: IListOption | null) {
        console.log("onStateChange");
        console.log(value);
        this.setState({ selectedState: value }, () => {
            if (this.props.onChange) {
                this.props.onChange(value);
            }
       });
    }

    render() {
        return (
            <Form.Group className={this.props.className}>
                <Form.Label>{this.props.label}</Form.Label>
                <Select
                    options={stateOptions}
                    value={this.state.selectedState}
                    placeholder={this.props.placeholder ? this.props.placeholder : "Please select..." }
                    onChange={(v) => this.onStateChange(v ? { value: v["value"], label: v["label"] }: null)}
                    //components={{ Option }}
                    isDisabled ={this.props.disabled}
                    className={this.props.validated ? (this.props.validationError ? "is-invalid" : "is-valid") : ""}
                    styles={slectColourStyles}
                    isClearable={false} />
                {this.props.validated && this.props.validationError
                    ? <Form.Control.Feedback type="invalid">
                        {this.props.validationError}
                    </Form.Control.Feedback>
                    : null
                }
            </Form.Group>
        );
    }
}

export default StateList;